export default __webpack_public_path__ + "static/media/surat-jalan-penjualan.b2fc347d.png";